import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FieldDetailsFragmentGql } from './FieldDetailsFragmentGql';

export const FieldDetailsQueryGql: DocumentNode = gql`
query FieldDetailsQuery($fieldId: ID!) {
  fields(filter: { id: $fieldId }) {
    ...FieldDetailsFragment
  }
}
${FieldDetailsFragmentGql}
`;
